<template>
  <div v-if="showDebugInfo" class="pusher-status">
    <button @click="toggleDebugInfo" class="debug-toggle-btn">
      <span class="icon">{{ hideDebugInfo ? "▶" : "▼" }}</span>
    </button>
    <div v-if="!hideDebugInfo">
      <div class="status-item">
        <span class="label">Connection:</span>
        <span :class="['status', isConnected ? 'connected' : 'disconnected']">
          {{ isConnected ? "Connected" : "Disconnected" }}
        </span>
      </div>
      <div class="status-item">
        <span class="label">Subscription:</span>
        <span :class="['status', isSubscribed ? 'subscribed' : 'unsubscribed']">
          {{ isSubscribed ? "Subscribed" : "Unsubscribed" }}
        </span>
      </div>
      <div class="status-item">
        <span class="label">User:</span>
        <span class="channel"
          >{{ expectedUserChannel || "user.?" }}
          <span
            :class="['status', isUserChannelSubscribed ? 'subscribed' : 'unsubscribed']"
            >{{ isUserChannelSubscribed ? "on" : "off" }}</span
          ></span
        >
      </div>
      <div class="status-item">
        <span class="label">Conv:</span>
        <span class="channel"
          >{{ expectedConversationChannel || "conversation.?" }}
          <span
            :class="[
              'status',
              isConversationChannelSubscribed ? 'subscribed' : 'unsubscribed',
            ]"
            >{{ isConversationChannelSubscribed ? "on" : "off" }}</span
          ></span
        >
      </div>
      <div v-if="conversationChannels?.length" class="status-item">
        <span class="label">Note:</span>
        <span class="channel">Subscribed on chat open; unsubscribed on leave</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, onMounted } from "vue";
import { usePusher } from "@/composables/usePusher";
import { useAuth } from "@/services/AuthService";

const {
  isConnected,
  isSubscribed,
  conversationChannels,
  expectedUserChannel,
  expectedConversationChannel,
  isUserChannelSubscribed,
  isConversationChannelSubscribed,
} = usePusher();
const { isAuthenticated } = useAuth();
const hideDebugInfo = ref(false);

// Only show debug info in development mode
const showDebugInfo = computed(() => {
  return import.meta.env.VITE_MODE === "development" && isAuthenticated.value;
});

onMounted(() => {
  const saved = localStorage.getItem("hideDebugInfo");
  hideDebugInfo.value = saved ? JSON.parse(saved) : false;
});

const toggleDebugInfo = () => {
  hideDebugInfo.value = !hideDebugInfo.value;
  localStorage.setItem("hideDebugInfo", JSON.stringify(hideDebugInfo.value));
};
</script>

<style scoped>
.pusher-status {
  position: fixed;
  bottom: 85px;
  right: 15px;
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 12px;
  border-radius: 6px;
  font-size: 12px;
  z-index: 9999;
}

.debug-toggle-btn {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
  border-radius: 6px;
  cursor: pointer;
  margin-left: auto;
}

.debug-toggle-btn:hover {
  background: rgba(255, 255, 255, 0.2);
}

.status-item {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
}

.status-item:last-child {
  margin-bottom: 0;
}

.label {
  font-weight: bold;
  min-width: 80px;
}

.status {
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 10px;
  text-transform: uppercase;
}

.connected {
  background: #10b981;
  color: white;
}

.disconnected {
  background: #ef4444;
  color: white;
}

.subscribed {
  background: #3b82f6;
  color: white;
}

.unsubscribed {
  background: #f59e0b;
  color: white;
}

.channel {
  color: #60a5fa;
  font-weight: bold;
}
</style>
